import { OrkevaMark } from "@/components/brand/OrkevaMark";

/**
 * Official ORKEVA lockup: gold mark + "ORKEVA" wordmark (+ optional tagline).
 * dark=true renders the wordmark in white for dark surfaces.
 */
export function Logo({
  className = "",
  showText = true,
  showSubtitle = false,
  subtitle = "The AI Decision Engine",
  dark = false,
  size = 32,
  align = "row",
}) {
  const wordmark = dark ? "text-white" : "text-foreground";
  const sub = dark ? "text-white/70" : "text-muted-foreground";

  if (align === "lockup") {
    const rule = (
      <span
        className="h-px w-5 shrink-0"
        style={{ background: "hsl(var(--brand-gold))", opacity: dark ? 0.75 : 0.6 }}
      />
    );
    return (
      <div className={`flex items-center gap-3.5 ${className}`} data-testid="orkeva-logo">
        <OrkevaMark size={size} />
        <div className="flex flex-col">
          <span className={`font-display text-[26px] font-extrabold leading-none tracking-tight ${wordmark}`}>
            ORKEVA
          </span>
          <div className="mt-2 flex items-center gap-2">
            {rule}
            <span className={`whitespace-nowrap text-[9px] font-semibold uppercase tracking-[0.3em] ${sub}`}>
              {subtitle}
            </span>
            {rule}
          </div>
        </div>
      </div>
    );
  }

  if (align === "col") {
    return (
      <div className={`flex flex-col items-center gap-3 ${className}`} data-testid="orkeva-logo">
        <OrkevaMark size={size} />
        {showText && (
          <div className="flex flex-col items-center">
            <span className={`font-display text-2xl font-extrabold tracking-tight ${wordmark}`}>
              ORKEVA
            </span>
            {showSubtitle && (
              <span className={`mt-0.5 text-[11px] font-medium uppercase tracking-overline ${sub}`}>
                {subtitle}
              </span>
            )}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="orkeva-logo">
      <OrkevaMark size={size} />
      {showText && (
        <div className="flex flex-col leading-none">
          <span className={`font-display text-xl font-extrabold tracking-tight ${wordmark}`}>
            ORKEVA
          </span>
          {showSubtitle && (
            <span className={`mt-0.5 text-[10px] font-medium uppercase tracking-overline ${sub}`}>
              {subtitle}
            </span>
          )}
        </div>
      )}
    </div>
  );
}
